import React, { useState, useEffect } from 'react';
import moment from 'moment';


const Timer = () => {
  const [startDate] = useState(moment());
  const [delay, setDelay] = useState(0);

  const tick = () => {
    setDelay(moment(moment() - moment(startDate)).format('mm:ss'));
  };

  useEffect(() => {
    const id = setInterval(tick, 100);
    return () => {
      clearInterval(id);
    };
  }, []);
  return <div className="timer">{delay}</div>;
};

export default Timer;